import React from "react";
import DropdownRight from "./DropdownRight";
import HeaderLeft from "./HeaderLeft";
import { Link } from "react-router-dom";

function Wallet(props) {
  return (
    <>
      <header>
        <div class="custom_container ">
          <HeaderLeft />
          <div class="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>
      <section class="otp_verification custom_hight">
        <div class="login_inner">
          <h1 class="mb_30 main_title ">Wallet</h1>
          <p class="mb_40 them_para text-center mx-auto text_limit">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim{" "}
          </p>
          <div class="list_detail">
            <ul>
              <li>
                {" "}
                Current Balance<span>$232.23</span>{" "}
              </li>
              <li>
                {" "}
                Total Earnings<span>$362.23</span>{" "}
              </li>
            </ul>
          </div>
          <Link to="/logout">
            <div class="btn_wraper">
              <button type="button" class="them_btn mt_40 mb_30">
                Go back
              </button>
            </div>
          </Link>
        </div>
      </section>
    </>
  );
}

export default Wallet;
